app.directive('validCode', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attrs, ctrl) {
            ctrl.$parsers.unshift(function (viewValue) {
                var code_regexp = /^[a-zA-Z0-9]+$/;
                // console.log(viewValue);

                var valid = code_regexp.test(viewValue);
                // console.log(valid);


                ctrl.$setValidity('validCode', valid);
                return valid ? viewValue : undefined;
            });
        }
    };
});